// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessRigOffshore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.708 2H13.52a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5h-.477l.664 5h.989l3.917-5.627A.858.858 0 0 1 19.317 3c.669 0 1.086.755.75 1.358L17.483 9h1.407c.53 0 .96.448.96 1v4.014c.512.09.875.6.785 1.153l-.65 4a.972.972 0 0 1-.946.833h-1.139v1c0 .552-.43 1-.96 1h-2.953c-.53 0-.96-.448-.96-1v-1h-1.95v1c0 .552-.43 1-.96 1H7.162c-.53 0-.96-.448-.96-1v-1H5.064a.972.972 0 0 1-.946-.833l-.65-4c-.1-.61.352-1.167.946-1.167h.441l1.33-10h-.477a.49.49 0 0 1-.48-.5v-1c0-.276.215-.5.48-.5zM7.82 6.5h3.589L11.076 4H8.152zM18.552 16H5.55l.325 2h2.247v2h1.034v-2h5.79v2h1.033v-2h2.248zm-.143-5.5h-4.501l.465 3.5h4.036zM12.14 12H7.09l-.266 2h5.582zm-.531-4H7.62l-.332 2.5h4.652z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessRigOffshore;
